<template>
  <div>
    <global-table
      :table-data="customerGroupHistory"
      :loading="loading"
      :per-page="10"
      :table-detail="tableDetail"
      :bordered="true"
      :hover="true"
      :striped="false"
      :id-modals="'customerGroupHistory'"
      :redirect-detail="false"
      :edit-button="false"
      :show-add-button="false"
      :remove-button="false"
      :fields="fieldsCustomerGroupHistory"
      addButton="History Group Outlet"
    ></global-table>


  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "asset-return",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    },
    customerGroupHistory: {
      type: [Array],
      default: () => []
    },
    loading: {
      type: Boolean,
      default: true
    },
    childAddButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fieldsCustomerGroupHistory: [
        {
          key: "prev_customer_group_name",
          label: "Grup Outlet Sebelumnya",
          sortable: true
        },
        { key: "now_customer_group_name", label: "Grup Outlet Sekarang" },
        { key: "inserted_by_name", label: "Di Ubah Oleh" },
        { key: "date_updated", label: "Tanggal Update" }
      ],
      customerAssetReturnForm: interfaces.customer_asset,
      loadingSubmit: false
    };
  },
  validations: {
    customerAssetReturnForm: {
      assign_return_to: { required },
      customer_asset_id: { required },
      return_date: { required },
      description_return: { required },
      asset_status: {required}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {},
    reload(cust_id) {
      this.$emit("reload", cust_id);
    },
    editForm: function() {},
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
